export enum PricingPageContainer {
  Modal = 'modal',
  Page = 'page',
}
